import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import history from "../../../../route/history";
import InboxForm1 from "./form/InboxForm1";
import InboxForm2 from "./form/InboxForm2";
import {alertActions, authActions, inboxActions} from "../../../../store/actions";
import {commons} from "../../../../hook/common";
import ServiceDashboard from '../../../../layout/service/ServiceDashBoard' // 2021.06 DashBoard 추가

const CertificateDetail = props => {
  const queryString = require('query-string');

  const [ state, setState ] = useState({
    isToggle: false,
  });
  const [ historyInfo, setHistoryInfo] = useState({});
  const [ inboxInfo, setInboxInfo ] = useState({});
  const [ inboxTransSts, setInboxTransSts ] = useState("");

  useEffect(() => {
    const locationInfo = props.location.state;

    setHistoryInfo({
      ...historyInfo,
      selectedSubject: locationInfo?.selectedSubject,
      tabStatus: locationInfo?.tabStatus,
      srhFrom: locationInfo?.srhFrom,
      srhTo: locationInfo?.srhTo,
      srhKind: locationInfo?.srhKind,
      pageIdx: locationInfo?.pageIdx || 0
    })

    if (props.match.params.seq) {
      let crtSeq = props.match.params.seq;
      props.getInboxInfo(crtSeq);
    } else {

    }
  }, []);

  useEffect(() => {
    if (props.inboxInfo) {
      setInboxInfo(props.inboxInfo);
      setInboxTransSts(props.inboxInfo?.transSts);
    } else {

    }
  }, [props.inboxInfo]);


  useEffect(() => {
    if (props.isDelete) { // 수신함 삭제 성공
      goList();
    } else { // 변경 실패

    }
  }, [props.isDelete]);

  useEffect(() => {
    if (props.isFailure) { // 수신함 조회 실패시 데이터 초기화
      setInboxInfo({});
    }
  }, [props.isFailure]);

  useEffect(() => {
  }, [props.isSubDoc]);

  const goList = () => {
    let paramStr = queryString.stringify(historyInfo);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )
    history.push('/service/inbox' + paramStr)
  }

  const onPDFView = () => {
    const fileList = props.inboxInfo?.fileList;

    //파일 이관 체크
    if(inboxTransSts === "01") {
      props.subInboxDocPdf(props.inboxInfo?.crtSeq);

      props.success({
        title: '증명서 이관 요청',
        message: '증명서 보관기관이 경과되어 파일이 이관되었습니다.\n재이관을 요청하였으며 10분 정도 소요됩니다.'
      });

      goList();

      return;
    }else if(inboxTransSts === "02") {
      if(fileList != null) {
        props.success({
          title: '증명서 이관 요청중',
          message: '증명서 보관기관이 경과되어 파일이 이관되었습니다.\n재이관을 요청하였으며 10분 정도 소요됩니다.'
        });
        return;
      }else {
        //FIXME authentificate download
        // commons.openSubmitPdf(props.inboxInfo?.crtSeq);
        let crtSeq = props.inboxInfo?.crtSeq        
        let _anchor = document.createElement('a');
        _anchor.style = 'display:none;';
        document.body.appendChild(_anchor);
        
        let url = process.env.REACT_APP_API_URL + '/portal/pdf/submit/'+ crtSeq;
        _anchor.href = url;
        _anchor.click();  
        document.body.removeChild(_anchor);


      }
    }else {
      if (!fileList || ! fileList.length) {
        props.error({message: 'PDF 파일이 존재하지 않습니다.'});
        return;
      }
      //열지말고 다운으로 수정
      // commons.openPdf(fileList[0].fileId);
      
      // let _anchor = null;
      // _anchor = document.createElement('a');
      // _anchor.style = 'display:none;';
      // document.body.appendChild(_anchor);
      
      // fileList.forEach((val, idx, arr) => {
      //   setTimeout(() => {
      //     let url = process.env.REACT_APP_API_URL + '/portal/file/general/'+ fileList[idx].encryptedId;
      //     _anchor.href = url;
      //     _anchor.click();
      //   }, 20);  
      // });

      fileList.forEach((val, idx, arr) => {
        setTimeout(() => {
          let url = process.env.REACT_APP_API_URL + '/portal/file/general/'+ fileList[idx].encryptedId
          let xhr = new XMLHttpRequest();
          xhr.responseType = 'blob';
          xhr.onload = function () {
            let _anchor = document.createElement('a');
            _anchor.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
            _anchor.download = val['originFileNm']; // Set the file name.
            _anchor.style.display = 'none';
            document.body.appendChild(_anchor);
            _anchor.click();
            document.body.removeChild(_anchor);
          };
          xhr.open('GET', url);
          xhr.send();
        }, 20);  
      })
    }
  }

  const onSubmit = () => {
    history.push({pathname: '/service/inbox/submit', state: inboxInfo});
  }

  const onDelete = () => {
    props.deleteInbox({crtRcvSeq: inboxInfo?.crtRcvSeq});
  }

  const onDropDown = () => {
    setState({
      ...state,
      isToggle: !state.isToggle
    })
  }
  window.onpopstate = function(event) {
    goList();
  }
    
    
  return (
    <>
      <div className="ServiceDashboard">
        <ServiceDashboard />
      </div>

      <div className="detail-table">
        <div className="service-title">
            <button className="btn btn-white btn-pre" onClick={goList}><span>이전페이지로 이동</span></button>
            받은문서
        </div>
        <div className="detail-btn">
          
          <button className="btn icon-pdf-down" onClick={(e) => {
            e.preventDefault();
            onPDFView();
          }}>PDF</button>
          {/* {
            (inboxInfo?.sts !== '10' && inboxInfo?.sts !== '11') &&
            <button className="btn icon-more-pop" onClick={onDropDown}>더보기</button>
          }
          {
            state.isToggle ?
              <div className="layerPop">
                <ul>
                  {
                    inboxInfo?.sts !== '12' &&
                    <li onClick={onSubmit}><label>제출</label></li>
                  }
                  <li onClick={onDelete}><label>삭제(폐기)</label></li>
                </ul>
              </div> : ''
          } */}
        </div>
        {
          inboxInfo?.crtCd === '01' &&
          <InboxForm1 data={inboxInfo}/>
        }
        {
          inboxInfo?.crtCd === '02' &&
          <InboxForm2 data={inboxInfo}/>
        }
      </div>
    </>
  )
}

const mapStateToProps = state => {
  return {
    inboxList: state.inbox?.inboxList?.list,
    inboxInfo: state.inbox?.inboxInfo,
    isDelete: state.inbox?.isDelete,
    pdfString: state.inbox?.pdfString,
    isFailure: state.inbox?.isFailure,
    isSubDoc: state.inbox?.isSubDoc,
  }
}

const actionCreators = {
  getInboxInfo: inboxActions.getInboxInfo,
  deleteInbox: inboxActions.deleteInboxList,
  success: alertActions.success,
  error: alertActions.error,
  getCurrentUser: authActions.getCurrentUser,
  initPdfFlag: inboxActions.initPdfFlag,
  subInboxDocPdf: inboxActions.subInboxDocPdf,
}

export default connect(
  mapStateToProps,
  actionCreators
)(CertificateDetail)
